import React from 'react'
import { useLocation } from 'react-router'
import { useStableArray } from '../../../lib/array/useStableArray'

export function useQueryParam(param: string = ''): string | null {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search).get(param), [param, search])
}

export function useQueryParams<K extends readonly string[]>(
  ...keys: K
): { [P in K[number]]: string | null } {
  const { search } = useLocation()
  // @ts-ignore
  const keysStable = useStableArray(keys)

  return React.useMemo(() => {
    const params = new URLSearchParams(search)
    return Object.fromEntries(keysStable.map(key => [key, params.get(key)]))
  }, [search, keys.length, ...keysStable])
}
